
import axios from "./settingInstance"
import { notifyOnboardingStatusChanged } from '@/features/onboarding/events'

export default async ({value, key}: {value: any, key:string}) => {
    const payload ={
        "value":value,
        "key": key
    };

    try {
        const response: any = await axios.post(`/settings`, payload);
        notifyOnboardingStatusChanged()
        return response.data
    } catch (error) {
        return null
    }
}
